import React, {
  createContext,
  useState,
  useContext,
  useEffect,
} from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // start true (we’re checking)

  useEffect(() => {
    const savedAuth = localStorage.getItem("authData");

    if (savedAuth) {
      try {
        const parsed = JSON.parse(savedAuth);
        if (parsed.user) {
          setUser(parsed.user);
        }
      } catch (error) {
        console.error("Error parsing auth data:", error);
        localStorage.removeItem("authData");
      }
    }

    setLoading(false); // ✅ always stop loading
  }, []);

  const login = (userData, token) => {
    const authData = { user: userData, token };
    localStorage.setItem("authData", JSON.stringify(authData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("authData");
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        login,
        logout,
        isAuthenticated: !!user,
        loading,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
